import React, { useEffect, Fragment } from "react";
import HeaderExtended from "../../components/layout/HeaderExtended";
import Miniaturas from "../../components/Miniaturas";

import { useDispatch }              from "react-redux";
import { 
    setCategoriasAction
}                                               from "../../actions/searchActions";

import { 
    getCategoriasR as getCats,
    getArticulosR as getArts,
    decodeToNumber as dToNumber,
    jsonDeserialize
}   from "../../API/request";
import Loading from "../../components/Loading";
import BtnSubir from "../../components/BtnSubir";


const Collection = (props) => {
    const dispatch = useDispatch();
    const showPrice = process.env.REACT_APP_SHOW_PRICE  === 'false' ? false : true;
    const [showLoading, setShowLoading] = React.useState(true);
    const [listadoCategorias, setListadoCategorias] = React.useState(null);
    const [categoriaActual, setCategoriaActual] = React.useState(null);

    const [listadoArticulos, setListadoArticulos] = React.useState(null);
    const [listadoArticulosNuevos, setListadoArticulosNuevos] = React.useState(null);
    const [listadoArticulosDestacados, setListadoArticulosDestacados] = React.useState(null);

    const collectionName = props.match.params.category;


    useEffect(() => {

        window.scrollTo(0, 0)

        setShowLoading(true);
        setListadoArticulos(null);
        setListadoArticulosNuevos(null);
        setListadoArticulosDestacados(null);
        setCategoriaActual(null);

        getArts(dToNumber(collectionName))
            .then( ( responseArticulos ) => {
                let arts = jsonDeserialize(responseArticulos.data.data);
                //console.log(arts);

                setCategoriaActual(arts.categoria)
                document.title = "Collection - " + arts.categoria;


                
                let hash = {};
                let artNotDuplicates = arts.articulos.data.filter(o => hash[o.nombre] ? false : hash[o.nombre] = true);
                //console.log(JSON.stringify(artNotDuplicates));

                let articulosNuevos = artNotDuplicates.filter( (item) =>  item.nuevo === "True");
                let articulosDestacados = artNotDuplicates.filter( (item) =>  item.destacado === "True");
                let articulosSinND = artNotDuplicates.filter( (item) =>  item.nuevo !== "True" && item.destacado !== "True" );
                

                //let articulosNuevos = arts.articulos.data.filter( (item) =>  item.nuevo === "True");
                //let articulosDestacados = arts.articulos.data.filter( (item) =>  item.destacado === "True");
                //let articulosSinND = arts.articulos.data.filter( (item) =>  item.nuevo !== "True" && item.destacado !== "True" );

                setListadoArticulos(articulosSinND.length > 0 ? articulosSinND : null)
                setListadoArticulosNuevos(articulosNuevos.length > 0 ? articulosNuevos : null)
                setListadoArticulosDestacados(articulosDestacados.length > 0 ? articulosDestacados : null)

                getCats()
                    .then( ( responseCategorias ) => {
                        let cats = jsonDeserialize(responseCategorias.data.data).data;
                        setListadoCategorias(cats);
                        dispatch(setCategoriasAction(cats));
                        setShowLoading(false);
                    })
                    .catch((errorMessageGetMantenimiento)=>{
                        console.log("ERORR - En la petición")
                    });
                
            })
            .catch((errorMessageGetMantenimiento)=>{
                console.log("ERORR - En la petición")
            });
    }, [collectionName,setListadoCategorias,setListadoArticulos,setCategoriaActual,setListadoArticulosNuevos,setListadoArticulosDestacados,dispatch]);


    return (
        <Fragment>
            {
                showLoading
                ?   <Loading/>
                :   <>
                        <HeaderExtended
                            category={collectionName}
                            menuType={false}
                            listado={listadoCategorias}
                            actual={categoriaActual}
                        />
                        <div className="content secondary">
                            {
                                listadoArticulosNuevos !== null &&
                                    <Miniaturas
                                        title="Nuevos"
                                        listArticulos={listadoArticulosNuevos}
                                        showPrice={showPrice}
                                    />
                            }
                            {
                                listadoArticulosDestacados !== null &&
                                    <Miniaturas
                                        title="Destacados"
                                        listArticulos={listadoArticulosDestacados}
                                        showPrice={showPrice}
                                    />
                            }
                            {
                                listadoArticulos !== null &&
                                    <Miniaturas
                                        title="Todos"
                                        listArticulos={listadoArticulos}
                                        showPrice={showPrice}
                                    />
                            }
                        </div>
                        <BtnSubir />
                    </>
            }
        </Fragment>
    );
};

export default Collection;
